var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpeechBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "speech-bubble-a",
    d: "M51.7091882,23.2881356 L62.0338983,23.2881356 C64.2152542,23.2881356 66,25.1644068 66,27.4576271 L66,64.9830508 L57.0677966,56.6440678 L30.3050847,56.6440678 C28.1237288,56.6440678 26.3389831,54.7677966 26.3389831,52.4745763 L26.3389831,43.8148631 L43.2471008,43.8148631 C47.9115211,43.8148631 51.7091882,39.8224438 51.7091882,34.9188225 L51.7091882,23.2881356 Z M41.6949153,6 C43.8762712,6 45.6610169,7.83050847 45.6610169,10.0677966 L45.6610169,34.4745763 C45.6610169,36.7118644 43.8762712,38.5423729 41.6949153,38.5423729 L14.9322034,38.5423729 L6,46.6779661 L6,10.0677966 C6,7.83050847 7.78474576,6 9.96610169,6 L41.6949153,6 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#speech-bubble-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpeechBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/speech-bubble.edd7a254ac0fbc204afa1184a53b9953.svg";